export const USER_RELATIONSHIP_TARGET = 'users'

export type SystemRelationshipTarget = typeof USER_RELATIONSHIP_TARGET

export function isUserRelationshipTarget(
  relationship: string | null | undefined
): relationship is SystemRelationshipTarget {
  return relationship === USER_RELATIONSHIP_TARGET
}

export function isSystemRelationshipTarget(
  relationship: string | null | undefined
): relationship is SystemRelationshipTarget {
  return isUserRelationshipTarget(relationship)
}
